module.exports = __webpack_public_path__ + "static/media/binance.d2e3bfc5.svg";